/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MaintenanceTicketDetailDto,
} from '../models/index';
import {
    MaintenanceTicketDetailDtoFromJSON,
    MaintenanceTicketDetailDtoToJSON,
} from '../models/index';

export interface MaintenanceTicketControllerGetByIdRequest {
    id: string;
    organizationId?: string;
}

/**
 * 
 */
export class MaintenanceExecutionTicketsApi extends runtime.BaseAPI {

    /**
     */
    async maintenanceTicketControllerGetByIdRaw(requestParameters: MaintenanceTicketControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaintenanceTicketDetailDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling maintenanceTicketControllerGetById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/maintenance-tickets/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaintenanceTicketDetailDtoFromJSON(jsonValue));
    }

    /**
     */
    async maintenanceTicketControllerGetById(requestParameters: MaintenanceTicketControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaintenanceTicketDetailDto> {
        const response = await this.maintenanceTicketControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
